import { render, staticRenderFns } from "./TokensIndex.vue?vue&type=template&id=1ec9071e&scoped=true&"
import script from "./TokensIndex.vue?vue&type=script&lang=js&"
export * from "./TokensIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9071e",
  null
  
)

export default component.exports